import { useMemo, useState } from 'react'

import { Button } from 'core-components/library/button'
import { Dropdown } from 'core-components/library/dropdown'
import {
  SeparatorAlignment,
  SeparatorColors,
  SeparatorHeight,
  SeparatorWidth,
  TSeparator,
} from 'core-components/library/richTextEditor/interface/TSeparator'
import { BaseCrud, Static } from 'core-components/types'

import styles from './SeparatorSettingsDialog.module.scss'

interface IProps {
  separatorSettings: TSeparator
  onCancel: () => void
  onSave: (separatorSettings: TSeparator) => void
}

export const SeparatorSettingsDialog = (props: IProps) => {
  const [editedSettings, setEditedSetting] = useState({
    ...props.separatorSettings,
  })

  const heightSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(SeparatorHeight),
      keyField: 'value',
    })
  }, [])

  const widthSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(SeparatorWidth),
      keyField: 'name',
    })
  }, [])

  const alignmentSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(SeparatorAlignment),
      keyField: 'name',
    })
  }, [])

  const colorSource = useMemo(() => {
    return new BaseCrud({
      fetcher: new Static(SeparatorColors),
      keyField: 'value',
    })
  }, [])

  return (
    <>
      <Dropdown
        source={heightSource}
        caption={'name'}
        value={editedSettings.height || ''}
        onChange={(value) => setEditedSetting((prev) => ({ ...prev, height: value }))}
        margin={'md'}
      />
      <Dropdown
        source={widthSource}
        caption={'name'}
        value={editedSettings.width || ''}
        onChange={(value) => setEditedSetting((prev) => ({ ...prev, width: value }))}
        margin={'md'}
      />
      <Dropdown
        source={alignmentSource}
        caption={'name'}
        value={editedSettings.alignment || ''}
        onChange={(value) => setEditedSetting((prev) => ({ ...prev, alignment: value }))}
        margin={'md'}
      />
      <Dropdown
        source={colorSource}
        caption={'name'}
        value={editedSettings.backgroundColor || ''}
        renderFunction={(item) => {
          return (
            <div className={styles.colorItem}>
              <div className={styles.colorPreview} style={{ backgroundColor: item.value }} />
              <div>{item.name}</div>
            </div>
          )
        }}
        onChange={(value) => {
          setEditedSetting((prev) => ({ ...prev, backgroundColor: value }))
        }}
        margin={'md'}
      />
      <div className={styles.buttons}>
        <Button className={styles.button} onClick={() => props.onSave(editedSettings)}>
          Save
        </Button>
        <Button className={styles.button} onClick={() => props.onCancel()}>
          Cancel
        </Button>
      </div>
    </>
  )
}
